const REDIRECT_SUB_DOMAIN_QUERY_KEY = 'redirectSubDomain'
const REDIRECT_SUB_DOMAIN_STORAGE_KEY = 'redirectSubDomain'

export default defineNuxtPlugin(() => {
  if (!process.client) return

  const currentUrl = new URL(window.location.href)
  const redirectSubDomain = currentUrl.searchParams.get(REDIRECT_SUB_DOMAIN_QUERY_KEY)

  if (!redirectSubDomain) return

  sessionStorage.setItem(REDIRECT_SUB_DOMAIN_STORAGE_KEY, redirectSubDomain)
  currentUrl.searchParams.delete(REDIRECT_SUB_DOMAIN_QUERY_KEY)

  const cleanedUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
  window.history.replaceState({}, '', cleanedUrl)
})
